import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const CheckboxCheckedSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M5.33224 22.0096H18.6678C20.8859 22.0096 22 20.8869 22 18.7063V5.30328C22 3.12277 20.8859 2 18.6678 2H5.33224C3.12376 2 2 3.11409 2 5.30328V18.7063C2 20.8955 3.12376 22.0096 5.33224 22.0096ZM10.7861 17.3146C10.4523 17.3146 10.1893 17.1858 9.93607 16.8467L7.07025 13.3712C6.92746 13.1855 6.84156 12.9665 6.84156 12.7474C6.84156 12.3041 7.17975 11.951 7.61443 11.951C7.89038 11.951 8.10938 12.0412 8.33904 12.3567L10.7432 15.3715L15.6078 7.63022C15.7935 7.334 16.0459 7.18156 16.3035 7.18156C16.7232 7.18156 17.1193 7.47148 17.1193 7.92547C17.1193 8.13582 16.9948 8.36448 16.88 8.5512L11.5923 16.8467C11.3925 17.1622 11.12 17.3146 10.7861 17.3146Z"
        fill={color}
      />
    </svg>
  );
};

export { CheckboxCheckedSvg };
